import {Component, signal, computed, OnDestroy} from '@angular/core';
import {UserDetailsStore} from '@stores/user-details.store';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'cloudlab-complete-profile-step2',
  templateUrl: './cloudlab-complete-profile-step2.component.html',
  styleUrls: ['./cloudlab-complete-profile-step.component.scss'],
  imports: [MatIconModule, MatButtonModule, TranslateModule],
})
export class CloudlabCompleteProfileStep2Component implements OnDestroy {
  gradeLevelOptions = [
    {key: 'gradeK2', label: 'complete-profile.gradeK2'},
    {key: 'grade35', label: 'complete-profile.grade35'},
    {key: 'grade68', label: 'complete-profile.grade68'},
    {key: 'grade912', label: 'complete-profile.grade912'},
    {key: 'higherEducation', label: 'complete-profile.higherEducation'},
    {key: 'otherNA', label: 'complete-profile.otherNA'},
  ];

  subjectOptions = [
    {key: 'physics', label: 'complete-profile.physics'},
    {key: 'chemistry', label: 'complete-profile.chemistry'},
    {key: 'biology', label: 'complete-profile.biology'},
    {key: 'generalScience', label: 'complete-profile.generalScience'},
    {key: 'earthScience', label: 'complete-profile.earthScience'},
    {key: 'otherNA', label: 'complete-profile.otherNA'},
  ];

  selectedGradeLevels = signal<string[]>([]);
  selectedSubjects = signal<string[]>([]);

  isValid = computed(
    () =>
      this.selectedGradeLevels().length > 0 &&
      this.selectedSubjects().length > 0,
  );

  constructor(private userDetailsStore: UserDetailsStore) {
    const state = this.userDetailsStore.state();
    this.selectedGradeLevels.set([...(state.gradeLevels || [])]);
    this.selectedSubjects.set([...(state.subjects || [])]);
  }

  ngOnDestroy() {
    this.saveToStore();
  }

  toggleGradeLevel(key: string) {
    this.selectedGradeLevels.update((levels) => {
      const index = levels.indexOf(key);
      return index >= 0
        ? levels.filter((_, i) => i !== index)
        : [...levels, key];
    });
    this.saveToStore();
  }

  toggleSubject(key: string) {
    this.selectedSubjects.update((subjects) => {
      const index = subjects.indexOf(key);
      return index >= 0
        ? subjects.filter((_, i) => i !== index)
        : [...subjects, key];
    });
    this.saveToStore();
  }

  isGradeLevelSelected(key: string): boolean {
    return this.selectedGradeLevels().includes(key);
  }

  isSubjectSelected(key: string): boolean {
    return this.selectedSubjects().includes(key);
  }

  saveToStore() {
    this.userDetailsStore.setGradeLevels([...this.selectedGradeLevels()]);
    this.userDetailsStore.setSubjects([...this.selectedSubjects()]);
  }
}
